const BaseModule = require('../../90_utils/base/BaseModule');

class CirclePlus extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$expandedCaption = this.$el.parent().find('.expanded-caption');
		this.$bgPanel = this.$expandedCaption.find('.bg-panel');
		this.$caption = this.$expandedCaption.find('.caption');
		this.$statBlock = this.$el.closest('.content-block--stat-block');

		this.$gradient = this.$el.find('>.gradient-circle');
		this.$plus = this.$el.find('>.icon-plus');

		this.isHover = false;
		this.isClickToggled = false;
		this.isAnimating = false;
		this.isStatBlock = this.$statBlock.length ? true : false;
	}

	// basemodule methods

	_domReady(){
		this._resetPositions();
	}

	_addListeners(){

		let options = {preventDefault:true};
		this.$el.hammer(options).on('tap', $.proxy(this._onClick, this))

		this.$el.on('click', $.proxy(this._onClick, this));
		this.$el.on('mouseenter', $.proxy(this._onMouseEnter, this));
		this.$el.on('mouseleave', $.proxy(this._onMouseLeave, this));
	}

	_removeListeners(){

		this.$el.hammer().off('tap', $.proxy(this._onClick, this))

		this.$el.off('click', $.proxy(this._onClick, this));
		this.$el.off('mouseenter', $.proxy(this._onMouseEnter, this));
		this.$el.off('mouseleave', $.proxy(this._onMouseLeave, this));

		$('#main').off('click', $.proxy(this._onOut, this));
	}

	// listener methods

	_onClick(e){
		this.toggle(true);
	}

	_onMouseEnter(e){
		this.isHover = true;
		this.toggle(false);
	}

	_onMouseLeave(e){
		this.isHover = false;
		this._checkHover();
		this.toggle(false);
	}

	_onOut(e){
		if(!this.$el[0].contains(e.target) && !this.$expandedCaption[0].contains(e.target)){
			this.toggle(true);
		}
	}

	//

	toggle(isClick){

		isClick = (isClick === true);

		if(!this.isAnimating && (!this.isClickToggled || (this.isClickToggled && isClick))){

			TweenMax.killTweensOf([this.$expandedCaption, this.$caption, this.$bgPanel]);

			let $caption = this.$expandedCaption.find('.caption');
			let panelHeight = Math.round(this.$bgPanel.outerHeight());

			if(this.$el.hasClass('is-active') && (!this.isHover || (this.isClickToggled && isClick))){

				this.$el.removeClass('is-active');
				this.isAnimating = true;

				if( this.$expandedCaption.length ){
					if(this.isStatBlock){
						let $statInner = this.$statBlock.find('>.inner-block');
						TweenMax.to(this.$expandedCaption, 0.16, {opacity:0, ease:'fadeOut'});
						TweenMax.to($statInner, 0.24, {paddingBottom:0, ease:'fadeOut'});
						TweenMax.to(this.$el, 0.24, {y:0, ease:'fadeOut'});
						TweenMax.to(this.$bgPanel, 0.24, {y:0, opacity:0, ease:'fadeOut'});
						TweenMax.to(this.$caption, 0.2, {y:panelHeight, opacity:0, ease:'fadeOut', onComplete:this._resetPositions.bind(this)});
					}
					else {
						TweenMax.to(this.$expandedCaption, 0.24, {opacity:0, ease:'fadeOut'});
						TweenMax.to(this.$bgPanel, 0.24, {y:0, opacity:0, ease:'fadeOut'});
						TweenMax.to(this.$caption, 0.2, {y:0, opacity:0, ease:'fadeOut', onComplete:this._resetPositions.bind(this)});
					}
				}
			}
			else if(!this.$el.hasClass('is-active') && this.isHover) {

				this.$el.addClass('is-active');
				this.isAnimating = true;

				if( this.$expandedCaption.length ){
					if(this.isStatBlock){
						let $statInner = this.$statBlock.find('>.inner-block');
						TweenMax.to([this.$expandedCaption, this.$bgPanel, this.$caption], 0.16, {visibility:'visible', opacity:1, ease:'fade'});
						TweenMax.to($statInner, 0.24, {paddingBottom:panelHeight, ease:'fade'});
						TweenMax.to(this.$el, 0.24, {y:panelHeight, ease:'fade'});
						TweenMax.to(this.$bgPanel, 0.24, {y:panelHeight, ease:'fade'});
						TweenMax.to(this.$caption, 0.3, {y:panelHeight, ease:'fade', onComplete:() => {
							this.isAnimating = false;
						}});
					}
					else {
						TweenMax.to([this.$expandedCaption, this.$bgPanel, this.$caption], 0.16, {visibility:'visible', opacity:1, ease:'fade'});
						TweenMax.to(this.$bgPanel, 0.16, {y:0, ease:'fade'});
						TweenMax.to(this.$caption, 0.24, {y:0, ease:'fade', onComplete:() => {
							this.isAnimating = false;
						}});
					}
				}
			}

			if(isClick){

				if(this.$el.hasClass('is-active')){

					this.isClickToggled = true;
					$('#main').off('click', $.proxy(this._onOut, this));

					window.requestAnimationFrame(() => {
						$('#main').on('click', $.proxy(this._onOut, this));
					});
				}
				else {
					this.isClickToggled = false;
					$('#main').off('click', $.proxy(this._onOut, this));
				}
			}
		}

		this._checkHover();
	}

	_checkHover(){

		TweenMax.killTweensOf([this.$gradient, this.$plus]);

		if(this.$el.hasClass('is-active')){
			TweenMax.to(this.$plus, 0.2, {rotation:45, ease:'fade'});
		}
		else {
			TweenMax.to(this.$plus, 0.2, {rotation:0, ease:'fade'});
		}

		if(this.isHover){
			TweenMax.to(this.$gradient, 0.2, {scale: 1.12, rotation:0.1, ease:'fade'});
		}
		else {
			TweenMax.to(this.$gradient, 0.2, {scale: 1.01, ease:'fade'});
		}
	}

	//

	_resetPositions(){

		this.isAnimating = false;

		if(this.isStatBlock){

			let panelHeight = this.$bgPanel.outerHeight();
			TweenMax.set(this.$bgPanel, {y:0, opacity:0});
			TweenMax.set(this.$caption, {y:panelHeight-12, opacity:0});
		}
		else {
			TweenMax.set(this.$bgPanel, {y:12, opacity:0});
			TweenMax.set(this.$caption, {y:12, opacity:0});
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){
	}
}

module.exports = CirclePlus;
